module.exports = __webpack_public_path__ + "guanao-pc/static/media/header-text.6cdd572e.png";